import { motion } from "framer-motion";
import { ShieldCheck } from "lucide-react";

const stats = [
  { k: "10+ YRS", v: "Running crypto markets" },
  { k: "10+ YRS", v: "Crisis accommodation ops" },
  { k: "$MILLIONS", v: "In gov-funded appropriations managed" },
];

export const FounderStrip = () => {
  return (
    <section className="relative bg-[#ff007f] py-16 sm:py-20 px-5 sm:px-6" data-testid="founder-section">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center gap-2 font-mono text-xs uppercase tracking-[0.3em] text-black/70 mb-5">
          <ShieldCheck className="w-4 h-4" /> Backed by real-world expertise
        </div>
        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.4 }}
          transition={{ duration: 0.7 }}
          className="font-display font-black uppercase tracking-tighter leading-[0.95] text-black text-3xl sm:text-4xl lg:text-5xl max-w-4xl"
        >
          Real credibility. A founder with a decade running crypto markets and
          front-line crisis accommodation.
        </motion.h2>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 mt-12">
          {stats.map((s, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.1 }}
              className="border-t-2 border-black pt-4"
              data-testid={`founder-stat-${i}`}
            >
              <div className="font-display font-black text-3xl sm:text-4xl text-black">{s.k}</div>
              <div className="font-mono text-sm text-black/70 mt-1">{s.v}</div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
